<page-title title="Localização"></page-title>

<page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
<page-alert [message]="messageWarning" *ngIf="showWarningMessage" alertClass="alert-warning"></page-alert>

<div class="row">
  <div class="col-xs-12 col-md-12">
    <form [formGroup]="locationForm">
      <div class="row">
        <div class="col-md-12">
          <mat-card class="extra-info">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Telefone de Referência</mat-label>
                  <input
                    mask="(00) 0000-00009"
                    prefix="+55 "
                    [dropSpecialCharacters]="true"
                    type="text"
                    matInput
                    formControlName="phone"
                    placeholder="Telefone Referência"
                    (paste)="onPasteName($event)"
                  />
                  <mat-error *ngIf="locationForm.get('phone')?.hasError('required')"> Campo obrigatório </mat-error>
                  <mat-error *ngIf="locationForm.get('phone')?.hasError('pattern')"> Formato Inválido </mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-4">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input type="text" matInput formControlName="email" placeholder="E-mail" />
                  <mat-error *ngIf="locationForm.get('email')?.hasError('required')"> Campo obrigatório </mat-error>
                  <mat-error *ngIf="locationForm.get('email')?.hasError('email')"> E-mail inválido </mat-error>
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-4">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Especialidade</mat-label>
                  <input type="text" matInput formControlName="specialty" placeholder="Especialidade" />
                  <mat-error *ngIf="locationForm.get('specialty')?.hasError('required')"> Campo obrigatório </mat-error>
                  <mat-error *ngIf="locationForm.get('specialty')?.hasError('pattern')"> Digite apenas letras </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div formGroupName="address">
        <div class="col-xs-12 col-md-6">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>CEP</mat-label>
            <input type="text" matInput formControlName="cep" mask="00000-000" placeholder="CEP" />
          </mat-form-field>
          <mat-error *ngIf="locationForm.get('address.cep')?.hasError('required') && locationForm.get('address.cep')?.touched">
            Campo obrigatório
          </mat-error>
          <mat-error *ngIf="locationForm.get('address.cep')?.touched && locationForm.get('address.cep')?.hasError('pattern')">
            CEP inválido. Formato esperado: 00000-000
          </mat-error>
          <mat-error *ngIf="cepError"> Nenhum endereço foi encontrado para este CEP. Verifique se está correto ou tente outro.</mat-error>
        </div>
        <!-- <div class="col-xs-12 col-md-4">
          <button mat-button color="primary" (click)="buscarCEP()" [disabled]="loading" class="formBt">Clique aqui para saber seu CEP</button>
        </div> -->
        <div class="col-xs-12 col-md-12">
          <mat-card class="google-maps">
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>País</mat-label>
                  <input type="text" formControlName="country" matInput placeholder="País" />
                  <mat-error *ngIf="locationForm.get('address.country')?.hasError('required')"> Campo obrigatório </mat-error>
                </mat-form-field>

                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Estado</mat-label>
                  <input type="text" matInput formControlName="state" placeholder="Estado" />
                  <mat-error *ngIf="locationForm.get('address.state')?.hasError('required')"> Campo obrigatório </mat-error>
                </mat-form-field>

                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Cidade</mat-label>
                  <input type="text" matInput formControlName="city" placeholder="Cidade" />
                  <mat-error *ngIf="locationForm.get('address.city')?.hasError('required')"> Campo obrigatório </mat-error>
                </mat-form-field>

                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Logradouro</mat-label>
                  <input type="text" matInput formControlName="street" placeholder="Logradouro" />
                  <mat-error *ngIf="locationForm.get('address.street')?.hasError('required')"> Campo obrigatório </mat-error>
                </mat-form-field>

                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Número</mat-label>
                  <input type="text" matInput formControlName="number" placeholder="Número" />
                  <mat-error *ngIf="locationForm.get('address.number')?.hasError('required')"> Campo obrigatório </mat-error>
                </mat-form-field>

                <mat-form-field class="example-full-width" appearance="outline">
                  <mat-label>Complemento</mat-label>
                  <input type="text" matInput formControlName="complement" placeholder="Complemento" />
                </mat-form-field>
              </div>

              <div class="col-xs-12 col-md-6 map-column">
                <h2 class="error-color" *ngIf="latLong[0] == 0 && !loading">Necessário Indicar o Local de atendimento no mapa</h2>
                <app-libremap-view
                  *ngIf="!loading && latLong[0] != 0"
                  [draggable]="true"
                  [latLong]="latLong"
                  (latLongChange)="onLatLongChange($event)"
                >
                </app-libremap-view>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-xs-12 col-md-6 map-link-field">
        <mat-form-field class="example-full-width" appearance="outline">
          <mat-label>Link Google Map</mat-label>
          <input type="text" matInput formControlName="mapUrl" placeholder="Link google maps" />
          <mat-error *ngIf="locationForm.get('address.mapUrl')?.hasError('required')"> Campo obrigatório </mat-error>
        </mat-form-field>
      </div>

      <div class="col-xs-12 actions">
        <button [disabled]="locationForm.invalid || latLong[0] == 0 || cepError" mat-flat-button color="primary" (click)="create()">Salvar</button>
      </div>
    </form>
  </div>
</div>
